import { render, staticRenderFns } from "./staffHistory.vue?vue&type=template&id=35c1deea&scoped=true"
import script from "./staffHistory.vue?vue&type=script&lang=js"
export * from "./staffHistory.vue?vue&type=script&lang=js"
import style0 from "./staffHistory.vue?vue&type=style&index=0&id=35c1deea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c1deea",
  null
  
)

export default component.exports